import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wpcm-pre-dfind-amt"
}
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.amounts)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.amounts, (amnt) => {
          return (_openBlock(), _createElementBlock("li", {
            key: amnt,
            onClick: _withModifiers(($event: any) => ($setup.store.amount = $setup.convert(amnt)), ["prevent"])
          }, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass([
          'wpdonation-button',
          $setup.store.amount == $setup.convert(amnt) && 'active'
        ])
            }, _toDisplayString($setup.getSymbol()) + _toDisplayString($setup.convert(amnt)), 3 /* TEXT, CLASS */)
          ], 8 /* PROPS */, _hoisted_2))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : _createCommentVNode("v-if", true)
}